export default __webpack_public_path__ + "static/andres-urena-qSw5XKtUyus-unsplash-692c70866bf787d0a2b14918522799b4.jpg";